import styled from "styled-components";

export const Container = styled.div``;
export const ImageContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 40px;
  img {
    width: calc(25% - 30px);
    height: auto;
    max-height: 188px;
    object-fit: contain;
    cursor: pointer;
    justify-content: space-between;
  }
  @media (max-width: 768px) {
    padding: 0 30px;
    img {
      width: calc(50% - 30px);
    }
  }
`;
export const Wrapper = styled.div`
  max-width: 1440px;
  /* padding: 0 clamp(20px, 3.194vw, 46px); */
  margin: 0 auto;
  @media (max-width: 768px) {
    padding: min(5.11vw, 73px);
  }
`;
export const TextSection = styled.div``;

export const Text = styled.div`
  padding-top: clamp(39px, 4.69vw, 67px);
  .mobile-brands-logo {
    display: none;
    @media (max-width: 767px) {
      display: block;
      max-width: 100%;
      margin: 0 auto;
    }
  }
  .web-brands-logo {
    display: none;
    @media (min-width: 768px) {
      display: block;
      max-width: 100%;
      margin: 0 auto;
    }
  }
  .featured-ambassador-heading {
    margin-bottom: clamp(17px, 2.014vw, 29px);
    span {
      color: #095587;
    }
  }
  .featured-ambassador-sub-heading {
    font-size: min(1.4vw, 20px);
    line-height: min(1.82vw, 26px);
    text-align: center;
    color: #095587;
    @media (max-width: 768px) {
      max-width: 100%;
      font-size: 2.84vw;
      line-height: 3.5vw;
      margin-bottom: 2.42vw;
    }
  }
  h3,
  h2 {
    font-size: min(4.2vw, 60px);
    line-height: min(4.2vw, 60px);
    /* line-height: min(52px, 4.93vw, 70px); */
    font-family: "robotoblack";
    text-align: center;
  }
  h2 {
    color: #0e5789;
  }
  h3 {
    max-width: 1196px;
    margin: 0 auto;
    margin-bottom: 26px;
  }
  > p {
    max-width: 80%;
    margin: 0 auto;
    text-align: center;
    font-family: "robotoregular";
    margin-bottom: clamp(37px, 5.208vw, 75px);
    font-size: min(1.4vw, 20px);
    line-height: min(1.82vw, 26px);
    letter-spacing: -0.66px;
    font-family: "robotobold";
    margin-bottom: min(1.26vw, 18px);
    color: #095587;
    text-align: center;
    @media (max-width: 768px) {
      max-width: 100%;
      font-size: 2.84vw;
      line-height: 3.5vw;
      margin-bottom: 2.42vw;
    }
  }
  .banner {
    max-width: 100%;
    width: min(52.431vw, 755px);
    margin: 0 auto clamp(37px, 5vw, 72px);
    @media (max-width: 768px) {
      margin: 0 auto 2.42vw;
      width: 100%;
    }
  }
  .ambassadors-image {
    height: 100%;
    aspect-ratio: auto 755/935;
    width: min(56%, 755px);
    margin: 0px auto 30px;
    display: flex;
  }
  .ambassadors-logo {
    width: min(52.431vw, 755px);
    margin: 0 auto;
    display: flex;
    margin-bottom: 30px;
    height: min(11vw, 157px);
  }
  @media (max-width: 768px) {
    padding-top: 0;
    h2,
    h3,
    .featured-ambassador-heading {
      line-height: 4vw;
      margin-bottom: 2.42vw;
    }
  }
`;

export const SubText = styled.div`
  p {
    font-size: 16px;
    color: #095587;
    margin-bottom: 15px;
  }
  .ambassadors-seal {
    width: min(19.583vw, 282px);
    float: left;
    padding-right: min(1.736vw, 25px);
  }
  @media (max-width: 768px) {
    p {
      font-size: 12px;
      margin-bottom: 10px;
    }
  }
`;

export const AmbassadorText = styled.div`
  position: absolute;
  right: 0;
  left: 0;
  margin: 0 auto;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  > div {
    padding: 1px 30px;
    /* background: #00000078; */
    width: min(52.431vw, 755px);
    background: radial-gradient(#191919e2, #00000000);
    /* background: radial-gradient(#c5c3c3e0,#00000000); */
  }
  h5 {
    color: white;
    font-size: 22px;
    font-family: "Inter";
    cursor: pointer;
  }
  h2 {
    color: white;
    font-size: 30px;
    font-family: "Inter";
    font-weight: bold;
    cursor: pointer;
  }
  h6 {
    color: white;
    font-size: 16px;
    font-family: "Inter";
    cursor: pointer;
    :hover {
      text-decoration: underline;
    }
  }
`;
